export default {
      id: "close-elipse-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#close-elipse",
      toString: function () {
        return this.url;
      }
    }